/* eslint-disable prettier/prettier */
/* eslint-disable import/order */
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FC, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { PaperModal, SearchTextField } from '@bvi/common-components';
import { DamagesTable } from '@bvi/admin-panel/feature/damages/ui/damages-table';
import { AddDamageForm } from '@bvi/admin-panel/feature/damages/ui/add-damage-form';
import { styles } from '@bvi/admin-panel/feature/manage-list/ui/manage-base-table/style';

export const DamagesPage: FC = () => {
  const { t } = useTranslation('translation');

  const [isModalOpen, setModalOpen] = useState(false);
  const searchMethods = useForm<{ q: string }>({
    defaultValues: { q: '' },
    mode: 'onSubmit',
    reValidateMode: 'onBlur',
  });
  const q = searchMethods.watch('q') ?? '';
  const [debouncedQuery, setDebouncedQuery] = useState('');

  useEffect(() => {
    const id = window.setTimeout(() => {
      setDebouncedQuery(q.trim());
    }, 350);
    return () => window.clearTimeout(id);
  }, [q]);

  return (
    <Box sx={{ my: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box display="flex" alignItems="center" gap={2} sx={{ mb: 2 }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h5" fontWeight="bold">
            {t('damages.title')}
          </Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            paddingTop: '10px',
          }}
        >
          <Typography fontWeight="bold">
            <Box display="flex" alignItems="center">
              <Box sx={{ flex: '1 1 auto' }} />
              <FormProvider {...searchMethods}>
                <Box sx={styles.searchBoxContainer}>
                  <Box sx={styles.searchWrapper}>
                    <SearchTextField
                      field="q"
                      placeholder={
                        t('manageBaseTable.table.search.placeholder') as string
                      }
                      size="small"
                      fullWidth
                      sx={styles.searchField}
                    />
                  </Box>
                </Box>
              </FormProvider>
              <Button
                variant="outlined"
                size="small"
                onClick={() => setModalOpen(true)}
                sx={{ flexShrink: 0 }}
              >
                + {t('manageList.button.add')} {t('damages.title')}
              </Button>
            </Box>
          </Typography>
        </Box>
      </Box>
      <DamagesTable query={debouncedQuery} />
      <PaperModal open={isModalOpen} onClose={() => setModalOpen(false)}>
        <AddDamageForm
          onSuccess={() => setModalOpen(false)}
        />
      </PaperModal>
    </Box>
  );
};

